import JoinUsCard from './join-us-cards';

export default JoinUsCard;
